import { useMutation, useQueryClient } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import useToast from '@sdk/common/toast/useToast';
import getErrorForToast from '@sdk/api/utils/getErrorForToast';
import gettext from '@sdk/lang/gettext';

import { useAnnouncementsQueryCache } from '@web/announcements/hooks/useAnnouncementsQueryCache';
import { getAnnouncementsQueryKey } from '@web/announcements/utils/getQueryKey';

export const useDeleteAnnouncement = () => {
  const client = useQueryClient();
  const { setDeletedFlag } = useAnnouncementsQueryCache();
  const { announcements } = useSlingApi();
  const { showErrorToast, showSuccessToast } = useToast();

  const mutation = useMutation({
    mutationFn: (id: ID) => announcements.delete(id),
    onMutate: async (id) => {
      setDeletedFlag(id);

      const queryKey = getAnnouncementsQueryKey();
      await client.cancelQueries(queryKey, { exact: true });
    },
    onSuccess: async (id) => {
      showSuccessToast(gettext('Announcement deleted'));
      return id;
    },
    onError: (error, id) => {
      setDeletedFlag(id, false);
      showErrorToast(getErrorForToast(error));
    },
    onSettled: async () => {
      const queryKey = getAnnouncementsQueryKey();
      await client.invalidateQueries(queryKey, { exact: true });
    },
  });

  return mutation;
};
